import {ToastType} from '@sportcast/ui-react';
import {Dispatch} from 'react';
import {v4} from 'uuid';
import {MessageProps} from '../../components/alert/Message';
import {AppThunk} from '../rootReducer';

export const SET_MESSAGE = 'SET_MESSAGE';

export interface MessageState {
    message: MessageProps | null;
}

interface MessageAction {
    type: typeof SET_MESSAGE,
    payload: MessageProps
}

export type MessageActionTypes = MessageAction;

export const setMessage = (message: MessageProps): AppThunk => {
    if (!message.messageId) {
        message.messageId = v4();
    }

    return (dispatch: Dispatch<MessageAction>) => {
        return dispatch({
            type: SET_MESSAGE,
            payload: message
        });
    };
};

export const setSuccessMessage = (text: string): AppThunk => {
    const successMessage: MessageProps = {
        messageId: v4(),
        message: text,
        autoClose: true,
        type: ToastType.SUCCESS
    };
    return setMessage(successMessage);
};
